// src/menu/utils.ts
function hasExpandedMenuButton(items, currentElement) {
  return !!(items == null ? void 0 : items.filter((item) => item.element !== currentElement).some((item) => {
    var _a;
    return ((_a = item.element) == null ? void 0 : _a.getAttribute("aria-expanded")) === "true";
  }));
}

export {
  hasExpandedMenuButton
};
